
import React from "react";
import { Badge } from "@/components/ui/badge";
import { sanitizeHtml } from "@/utils/sanitizer";

interface CourseHeaderProps {
  title: string;
  level: string;
  duration: string;
  status: string;
  description: string;
  isEnrolled: boolean;
  textDirection: "ltr" | "rtl";
}

const CourseHeader = ({
  title,
  level,
  duration,
  status,
  description,
  isEnrolled,
  textDirection,
}: CourseHeaderProps) => {
  return (
    <>
      <h1 className="text-3xl font-bold mb-4">{title}</h1>
      
      <div className="flex flex-wrap gap-2 mb-6">
        <Badge>{level} Level</Badge>
        <Badge variant="outline">{duration}</Badge>
        <Badge variant={status === "Enrolling" ? "default" : "secondary"}>
          {status}
        </Badge>
        {isEnrolled && (
          <Badge variant="green" className="bg-brand-green">Enrolled</Badge>
        )}
      </div>
      
      <div 
        className="prose max-w-none mb-8" 
        dir={textDirection}
        style={{
          textAlign: textDirection === "rtl" ? "right" : "left",
          direction: textDirection
        }}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }}
      />
    </>
  );
};

export default CourseHeader;
